import {IChangeLanguage, IFooterL10n} from "../interface/IFooter";
import ko from './l10n/ko';
import zh from './l10n/zh';
import ja from './l10n/ja';
import en from './l10n/en';
import th from './l10n/th';
import ru from './l10n/ru';
import id from './l10n/id';
import ar from './l10n/ar';

export const footerL10n: IFooterL10n = {
    ko: ko,
    zh: zh,
    ja: ja,
    en: en,
    th: th,
    ru: ru,
    id: id,
    ar: ar,
};

export const footerL10nLang: IChangeLanguage = {
    ko: "한국어",
    en: "English",
    zh: "中文－繁體",
    ja: "日本語",
    ar: "العربية",
    th: "ภาษาไทย",
    id: "Bahasa Indonesia",
    ru: "Русский"
};
